export function NinetyDayPlan({ plan }) {
  if (!plan) return null;
  const phases = [plan.phase_1, plan.phase_2, plan.phase_3].filter(Boolean);
  return (
    <section id="plano" className="acq-section">
      <div className="acq-container">
        <header>
          <span className="kicker">Plano de 90 dias</span>
          <h2>Como o comprador pode operar já desde o primeiro dia.</h2>
          <p className="section-lead">
            Plano de execução. Não promete resultados; organiza o arranque para minimizar surpresas.
          </p>
        </header>
        <div className="body card-list" data-testid="plan-list">
          {phases.map((phase, idx) => (
            <article className="card" key={phase.range}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="kicker">Fase {idx + 1}</span>
                <span className="chip chip-hypothesis">{phase.range}</span>
              </div>
              <h4>{phase.title}</h4>
              <ul style={{ margin: 0, paddingLeft: '1.1rem', fontSize: '.87rem', color: 'var(--muted)', lineHeight: 1.55 }}>
                {phase.actions.map((a) => (
                  <li key={a}>{a}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
